<template>
    <div class="container mt-5">
      <div class="row">
        <!-- Menu anësore (e majtë) -->
        <div class="col-md-3 pe-0">
          <ul class="nav flex-column nav-pills">
            <li v-for="(menu, index) in tabMenu" :key="menu.id" class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === index }"
                :href="'#tab' + menu.id"
                data-bs-toggle="pill"
                @click.prevent="activeTab = index">
                {{ $t(menu.title) }}
              </a>
            </li>
          </ul>
        </div>
  
        <!-- Përmbajtja (e djathtë) -->
        <div class="col-md-9 pt-0 ps-0 rounded boxcontainer">
          <div class="tab-content">
            <div style="margin-bottom: 15px;"
              v-for="(menu, index) in tabMenu"
              :key="menu.id"
              :id="'tab' + menu.id"
              class="tab-pane fade"
              :class="{ 'show active': activeTab === index }">
                <div style="margin-bottom: 15px;" v-if="menu.id === 3">
                  <h4 v-html="$t(menu.titlecontent)"></h4>
                  <div v-html="$t(menu.content)"></div>
                </div>
                <div style="margin-bottom: 15px;" v-else v-for="contentItem in menu.content" :key="contentItem.id">
                  <template v-if="Array.isArray(menu.content)">
                    <div style="margin-bottom: 15px;" v-for="contentItem in menu.content" :key="contentItem.id">
                      <h4 v-if="contentItem.title" v-html="$t(contentItem.title)"></h4>
                      <div v-if="Array.isArray(contentItem.content)">
                        <ul>
                          <li v-for="(item, idx) in contentItem.content" :key="idx" v-html="$t(item)"></li>
                        </ul>
                      </div>
                      <div v-else v-html="$t(contentItem.content)"></div>
                    </div>
                  </template>

                  <!-- Nëse është string -->
                  <template v-else>
                    <h4 v-if="menu.titlecontent" v-html="$t(menu.titlecontent)"></h4>
                    <div v-html="$t(menu.content)"></div>
                  </template>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
  data() {
    return {
      activeTab: 0,
      tabMenu: []
    };
  },
  methods: {
    initTabMenu() {
      this.tabMenu = [
        {
          id: 1,
          title: 'keshilli_prokurorial.secretariat.tab1.title',
          content: [
            {
              id: 1,
              title: 'keshilli_prokurorial.secretariat.tab1.content1.title',
              content: 'keshilli_prokurorial.secretariat.tab1.content1.content',
            }
          ],
        },
        {
          id: 2,
          title: 'keshilli_prokurorial.secretariat.tab2.title',
          content: [
            {
              id: 1,
              title: 'keshilli_prokurorial.secretariat.tab2.content1.title',
              content: 'keshilli_prokurorial.secretariat.tab2.content1.content',
            }
          ],
        },
        {
          id: 3,
          title: 'keshilli_prokurorial.secretariat.tab3.title',
          titlecontent: 'keshilli_prokurorial.secretariat.tab3.titlecontent',
          content: 'keshilli_prokurorial.secretariat.tab3.content',
        },
        {
          id: 4,
          titlecontent:"",
          title: 'keshilli_prokurorial.secretariat.tab4.title',
        },
        {
          id: 5,
          title: 'keshilli_prokurorial.secretariat.tab5.title',
          titlecontent: 'keshilli_prokurorial.secretariat.tab5.titlecontent',
          content: 'keshilli_prokurorial.secretariat.tab5.content',
        },
         {
          id: 6,
          title: 'keshilli_prokurorial.secretariat.tab6.title',
          titlecontent: 'keshilli_prokurorial.secretariat.tab6.titlecontent',
          content: 'keshilli_prokurorial.secretariat.tab6.content',
        },
         {
          id: 7,
          title: 'keshilli_prokurorial.secretariat.tab7.title',
          titlecontent: 'keshilli_prokurorial.secretariat.tab7.titlecontent',
          content: 'keshilli_prokurorial.secretariat.tab7.content',
        }
      ];
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initTabMenu();
    },
  },
  created() {
    this.initTabMenu();
  },
};
  </script>
  
  <style scoped>
  /* Efekti për animacion fade-in dhe slide */
  .tab-pane {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
    transform: translateX(20px);
    opacity: 0;
  }
  
  .tab-pane.active.show {
    transform: translateX(0);
    opacity: 1;
  }
  
  /* Stilimi i linkut të tabs */
  .nav-link {
    border-radius: 15px; /* Radius normal */
    transition: border-radius 0.3s ease;
  }
  
  /* Kur është aktiv, bëhet me kënd të drejtë */
  .nav-link.active {
    border-radius: 0 !important;
  }

  .row div ul .active, .tab-content{
    background-color:var(--color-system-background);
  }

  .tab-content{
    padding:40px;
  }

  li a{
    color:#101826;
    
  }

  li .active{
    color:#101826 !important;
    font-weight:bold;
    border-left:3px solid var(--color-system-primary);
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
  }

  li a{
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
  }

  @media(max-width:767px){
    .boxcontainer{
        margin-left:12px;
    }
  }

  </style>
